// Copyright (c) 2017 Deere & Company

import './index.scss';
import * as helpers from './helpers';
import React, {
    Component,
    PropTypes
} from 'react';
import DealerHierarchyTerritories from './dealer-hierarchy-territories';
import FacetFilter from '../facet-filter/';

class DealerHierarchy extends Component {

    state = {
        selectedAccounts: this.props.selectedAccounts,
        selectedCities: this.props.selectedCities,
        selectedLeadAccounts: this.props.selectedLeadAccounts,
        selectedTerritories: this.props.selectedTerritories,
        territories: this.props.territories
    };

    componentWillReceiveProps = nextProps => {

        this.setState({
            selectedAccounts: nextProps.selectedAccounts,
            selectedCities: nextProps.selectedCities,
            selectedLeadAccounts: nextProps.selectedLeadAccounts,
            selectedTerritories: nextProps.selectedTerritories,
            territories: nextProps.territories
        });

    };

    handleFilterChange = text => {

        const textToSearch = new RegExp(text, 'i');
        const filteredTerritories = helpers.filterTerritories(textToSearch, this.props.territories);
        const newSelections = helpers.generateSelectionMap(filteredTerritories);

        this.setState({
            territories: filteredTerritories
        });

        this.props.onDealerHierarchyChange({
            dealers: helpers.getListOfSelectedDealers(newSelections.selectedAccounts),
            ...newSelections
        });

    };

    handleAccountChange = (
        {
            accountsToCheck,
            selectedAccounts,
            selectedCity,
            selectedLeadAccount,
            selectedTerritory
        }
    ) => {

        const areAllAccountsSelected = helpers.isEverythingSelected(selectedAccounts);
        const areAllAccountsSelectedUnderThisCity = accountsToCheck.every(accountHash => selectedAccounts[accountHash]);

        const newSelectedTerritories = helpers.updateSelectedTerritories(this.state.selectedTerritories, areAllAccountsSelected, selectedTerritory);
        const newSelectedLeadAccounts = {...this.state.selectedLeadAccounts};
        const newSelectedCities = {...this.state.selectedCities};

        newSelectedLeadAccounts[selectedLeadAccount] = areAllAccountsSelected;
        newSelectedCities[selectedCity] = areAllAccountsSelectedUnderThisCity;

        const newSelections = {
            selectedAccounts,
            selectedCities: newSelectedCities,
            selectedLeadAccounts: newSelectedLeadAccounts,
            selectedTerritories: newSelectedTerritories
        };

        this.setState(newSelections);

        this.props.onDealerHierarchyChange({
            dealers: helpers.getListOfSelectedDealers(selectedAccounts),
            ...newSelections
        });

    };

    handleCityChange = (
        {
            citiesToCheck,
            city,
            selectedLeadAccount,
            selectedCities,
            selectedCity,
            selectedTerritory
        }
    ) => {

        const isSelected = selectedCities[selectedCity];

        const areAllCitiesSelected = helpers.isEverythingSelected(selectedCities);
        const areAllCitiesSelectedUnderThisLeadAccount = citiesToCheck.every(cityHash => selectedCities[cityHash]);

        const newSelectedTerritories = helpers.updateSelectedTerritories(this.state.selectedTerritories, areAllCitiesSelected, selectedTerritory);
        const newSelectedLeadAccounts = {...this.state.selectedLeadAccounts};

        const newSelectedAccounts = helpers.updateSelectedAccountsInACity(city, this.state.selectedAccounts, isSelected);

        newSelectedLeadAccounts[selectedLeadAccount] = areAllCitiesSelectedUnderThisLeadAccount;

        const newSelections = {
            selectedAccounts: newSelectedAccounts,
            selectedCities,
            selectedLeadAccounts: newSelectedLeadAccounts,
            selectedTerritories: newSelectedTerritories
        };

        this.setState(newSelections);

        this.props.onDealerHierarchyChange({
            dealers: helpers.getListOfSelectedDealers(newSelectedAccounts),
            ...newSelections
        });

    };

    handleLeadAccountChange = (
        {
            leadAccount,
            selectedLeadAccount,
            selectedLeadAccounts,
            selectedTerritory
        }
    ) => {

        const isSelected = selectedLeadAccounts[selectedLeadAccount];
        const areAllLeadAccountsSelected = helpers.isEverythingSelected(selectedLeadAccounts);

        const newSelectedTerritories = helpers.updateSelectedTerritories(this.state.selectedTerritories, areAllLeadAccountsSelected, selectedTerritory);
        const newSelectedCities = helpers.updateSelectedCitiesInALeadAccount(leadAccount, this.state.selectedCities, isSelected);
        const newSelectedAccounts = helpers.updateSelectedAccountsInALeadAccount(leadAccount, this.state.selectedAccounts, isSelected);

        const newSelections = {
            selectedAccounts: newSelectedAccounts,
            selectedCities: newSelectedCities,
            selectedLeadAccounts,
            selectedTerritories: newSelectedTerritories
        };

        this.setState(newSelections);

        this.props.onDealerHierarchyChange({
            dealers: helpers.getListOfSelectedDealers(newSelectedAccounts),
            ...newSelections
        });

    };

    handleTerritoryChange = (
        {
            selectedTerritories,
            selectedTerritory,
            territory
        }
    ) => {

        const isSelected = selectedTerritories[selectedTerritory];

        const newSelectedTerritories = {...selectedTerritories};

        const newSelectedLeadAccounts = helpers.updateSelectedLeadAccountsInATerritory(territory, this.state.selectedLeadAccounts, isSelected);
        const newSelectedCities = helpers.updateSelectedCitiesInATerritory(territory, this.state.selectedCities, isSelected);
        const newSelectedAccounts = helpers.updateSelectedAccountsInATerritory(territory, this.state.selectedAccounts, isSelected);

        const newSelections = {
            selectedAccounts: newSelectedAccounts,
            selectedCities: newSelectedCities,
            selectedLeadAccounts: newSelectedLeadAccounts,
            selectedTerritories: newSelectedTerritories
        };

        this.setState(newSelections);

        this.props.onDealerHierarchyChange({
            dealers: helpers.getListOfSelectedDealers(newSelectedAccounts),
            ...newSelections
        });

    };

    render() {

        return (
            <section className='dealer-hierarchy'>
                {this.props.useInBuiltFilter &&
                    <FacetFilter
                        onFilterChange={this.handleFilterChange}
                        placeholder={this.props.filterPlaceholder}
                    />
                }
                <DealerHierarchyTerritories
                    onAccountChange={this.handleAccountChange}
                    onCityChange={this.handleCityChange}
                    onLeadAccountChange={this.handleLeadAccountChange}
                    onTerritoryChange={this.handleTerritoryChange}
                    selectedAccounts={this.state.selectedAccounts}
                    selectedCities={this.state.selectedCities}
                    selectedLeadAccounts={this.state.selectedLeadAccounts}
                    selectedTerritories={this.state.selectedTerritories}
                    territories={this.state.territories}
                />
            </section>
        );

    }

}

DealerHierarchy.displayName = 'DealerHierarchy';
DealerHierarchy.propTypes = {
    filterPlaceholder: PropTypes.string.isRequired,
    onDealerHierarchyChange: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.object,
    selectedCities: PropTypes.object,
    selectedLeadAccounts: PropTypes.object,
    selectedTerritories: PropTypes.object,
    territories: PropTypes.array.isRequired,
    useInBuiltFilter: PropTypes.bool
};
DealerHierarchy.defaultProps = {
    useInBuiltFilter: true
};

export default DealerHierarchy;



// WEBPACK FOOTER //
// ./src/shared/components/facets/dealer-hierarchy/index.js